
import PPromise from 'p-progress';
import { IContainer, ILazyBinder, injectContainer } from './container';
import { IFetchRequest } from './util';

export enum IServiceWorkerStatus {
    Off = 0,
    Idle = 1,
    Starting = 2,
    Running = 3,
    Stopped = 4,
}

export interface IServiceWorker {
    status: IServiceWorkerStatus;
    start: () => void;
    stop: () => void;

    isInterceptingNetworkRequests: () => boolean;

    addCacheFirst: (matcher: RegExp, maxAge: number, maxEntries: number, cacheName: string) => void;
    addOAuthTokenCache: (pathSuffix: string) => void;
    addZipPathFetchResponder: (zipPath: string, relativeRespondPath: string) => void;
    addHeader: (matcher: RegExp, headerKey: string, headerVal: string, expiration: Date) => void;

    isRequestCached: (request: IFetchRequest, cacheName?: string) => Promise<boolean>;
    addRequestsToCache: (requests: Array<IFetchRequest>, cacheName: string) => PPromise<void>;
}

const TYPES = {
    IServiceWorker: Symbol.for("IServiceWorker"),
}

export function injectServiceWorker(container: IContainer = injectContainer()): Promise<IServiceWorker> {
    return container.get<ILazyBinder<IServiceWorker>>(TYPES.IServiceWorker)();
}

export function bindServiceWorker(binder: ILazyBinder<IServiceWorker>, container: IContainer = injectContainer()) {
    container.bind<ILazyBinder<IServiceWorker>>(TYPES.IServiceWorker, binder);
}
